import React, { Component } from 'react';
import firebase from 'firebase';
import { Grid, Row, Col, ListGroup, ListGroupItem, Badge } from 'react-bootstrap';
//import { Bar } from 'react-chartjs';
import DetailUser from './DetailUser';
import Loading from '../../components/Loading';

type IProps = {
  room: string,
}

type IState = {
  users: Object,
  selectedKey: string,
  loading: boolean,
}

class Users extends Component {

  constructor() {
    super();

    this.state = {
      users: {},
      selectedKey: '',
      loading: true,
    };
  }

  state: IState;

  componentDidMount() {
    const { room } = this.props;

    firebase.database()
    .ref('users')
    .orderByChild(`rooms/${room}`)
    .equalTo(true)
    .on('value', (snapshot) => {
      this.setState({
        users: snapshot.val() || {},
        loading: false,
      });
    });
  }

  handleSelect(key: string) {
    this.setState({
      selectedKey: key,
    });
  }

  props: IProps;

  render() {
    if (this.state.loading) return <Loading />;
    
    const { room } = this.props;
    const { users, selectedKey } = this.state;

    const sortedUsersInArray = Object.keys(users).map(key => users[key]).sort((a, b) => a.name < b.name ? -1 : 1);

    return (
      <Grid>
        <Row style={{ marginBottom: '30px' }}>
          <Col xs={12}>
            <div style={{ float: 'right' }}>
              <Badge bsStyle="default">{sortedUsersInArray.length} users</Badge>
            </div>
          </Col>
        </Row>
        <ListGroup>
        {
          sortedUsersInArray.map((user, index) => {
            const key = Object.keys(users)[index];

            return (
              <ListGroupItem key={key} header={`${user.name} (${user.email})`} onClick={(e) => this.handleSelect(key)}>
                {
                  key === selectedKey && <DetailUser room={room} user={user} />
                }
              </ListGroupItem>
            );
          })
        }
        </ListGroup>
        {
          sortedUsersInArray.length === 0 && <p>No users in your room.</p>
        }
      </Grid>
    );
  }
}

export default Users;



// WEBPACK FOOTER //
// ./src/pages/Users/index.js